<template>
  <div>
    <v-responsive :aspect-ratio="21/13" max-width="500" class="my-3">
      <canvas
        ref="canvas"
        @mousedown="mousedown"
        @mousemove="mousemove"
        @mouseout="mouseout"
        @mouseup="mouseup"
        @touchend="draw"
        @touchmove.prevent="draw"
        @touchstart="draw"
      ></canvas>
    </v-responsive>
    <p class="caption">Firmado por el {{ humanRol }} el dia {{ fecha }}</p>
    <v-layout justify-space-between>
      <v-btn @click="limpiar">Limpiar</v-btn>
      <v-btn color="primary" @click="enviar">Enviar</v-btn>
    </v-layout>
    <v-snackbar v-model="snackbar" bottom :timeout="3000">¡No has dibujado nada!</v-snackbar>
  </div>
</template>

<script>
export default {
  name: 'Firma',
  computed: {
    humanRol () {
      return this.rol.replace('tecnico', 'técnico de').replace('capataz', 'capataz de')
    },
    fecha () {
      return new Date().toLocaleDateString()
    }
  },
  data () {
    return {
      context: null,
      drawing: false,
      snackbar: false
    }
  },
  mounted () {
    this.context = this.$refs.canvas.getContext('2d')
    this.context.strokeStyle = ('#000000')
    this.context.lineJoin = 'round'
    this.context.lineWidth = 1
  },
  methods: {
    draw (event) {
      var coors = {
        x: event.targetTouches[0].pageX,
        y: event.targetTouches[0].pageY
      }
      var obj = this.$refs.canvas
      if (obj.offsetParent) {
        do {
          coors.x -= obj.offsetLeft
          coors.y -= obj.offsetTop
        } while (
          (obj = obj.offsetParent) != null
        )
        coors.x = coors.x * (this.$refs.canvas.width / this.$refs.canvas.offsetWidth)
        coors.y = coors.y * (this.$refs.canvas.height / this.$refs.canvas.offsetHeight)
        if (event.type === 'touchmove') {
          this.touchmove(coors)
        } else if (event.type === 'touchstart') {
          this.touchstart(coors)
        } else if (event.type === 'touchend') {
          this.touchend(coors)
        }
      }
    },
    drawLine (event) {
      var position = this.posicion(event)
      this.context.lineTo(position.X, position.Y)
      this.context.stroke()
    },
    enviar () {
      if (this.isCanvasBlank()) {
        console.log('Nope!')
        this.snackbar = true
      } else {
        this.$emit('enviar', this.$refs.canvas.toDataURL('image/png'))
      }
    },
    finishDrawing (event) {
      this.drawLine(event)
      this.context.closePath()
      this.drawing = false
    },
    isCanvasBlank (canvas) {
      const pixelBuffer = new Uint32Array(
        this.context.getImageData(0, 0, this.$refs.canvas.width, this.$refs.canvas.height).data.buffer
      )

      return !pixelBuffer.some(color => color !== 0)
    },
    limpiar () {
      this.context.clearRect(0, 0, this.$refs.canvas.width, this.$refs.canvas.height)
    },
    mousedown (event) {
      if (!this.drawing) {
        this.drawing = true
        var position = this.posicion(event)
        this.context.moveTo(position.X, position.Y)
        this.context.beginPath()
      }
    },
    mousemove (event) {
      if (this.drawing) {
        this.drawLine(event)
      }
    },
    mouseout (event) {
      if (this.drawing) {
        this.finishDrawing(event)
      }
    },
    mouseup (event) {
      if (this.drawing) {
        this.finishDrawing(event)
      }
    },
    posicion (mouseEvent) {
      const rect = this.$refs.canvas.getBoundingClientRect()
      return {
        X: Math.round((mouseEvent.clientX - rect.left) * (this.$refs.canvas.width / this.$refs.canvas.offsetWidth)),
        Y: Math.round((mouseEvent.clientY - rect.top) * (this.$refs.canvas.height / this.$refs.canvas.offsetHeight))
      }
    },
    touchend (coors) {
      if (this.drawing) {
        this.touchmove(coors)
        this.drawing = false
      }
    },
    touchmove (coors) {
      if (this.drawing) {
        this.context.lineTo(coors.x, coors.y)
        this.context.stroke()
      }
    },
    touchstart (coors) {
      this.context.beginPath()
      this.context.moveTo(coors.x, coors.y)
      this.drawing = true
    }
  },
  props: {
    indice: null,
    rol: String
  }
}
</script>
<style scoped>
canvas {
  border: 1px solid;
  width: 100%;
  height: 100%;
  margin: 0 0 0 0;
}
</style>
